import { cn } from '@/shared/ui/cn'
import { Avatar, AvatarFallback, AvatarImage } from '@/shared/ui/primitives'

type AvatarStackItem = {
  url?: string
  name: string
}

type AvatarStackProps = {
  avatars: AvatarStackItem[]
  max?: number
  className?: string
}

function AvatarStack({ avatars, max = 3, className }: AvatarStackProps) {
  if (avatars.length === 0) return null

  const visible = avatars.slice(0, max)
  const overflow = avatars.length - max

  return (
    <div
      data-slot="avatar-stack"
      className={cn('flex -space-x-2', className)}
    >
      {visible.map((avatar, index) => (
        <Avatar
          key={index}
          className="size-7 border-2 border-background"
        >
          {avatar.url ? <AvatarImage src={avatar.url} alt={avatar.name} /> : null}
          <AvatarFallback className="text-2xs">
            {avatar.name.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
      ))}
      {overflow > 0 ? (
        <div className="flex size-7 items-center justify-center rounded-full border-2 border-background bg-muted text-2xs font-medium text-muted-foreground">
          +{overflow}
        </div>
      ) : null}
    </div>
  )
}

export { AvatarStack }
export type { AvatarStackProps, AvatarStackItem }
